import Disclosure from '@pixelunion/shopify-cross-border';
import { transition } from '@pixelunion/animations';
import {
  trapFocus,
  removeTrapFocus,
} from '@shopify/theme-a11y';

import DrawerNavSubmenu from './DrawerNavSubmenu';

export default class DrawerNavStandard {
  constructor({ drawerTrigger }) {
    this.drawerTrigger = drawerTrigger;

    this.submenu = null;

    this.drawerNav = document.querySelector('[data-drawer-nav]');
    this.closeButton = this.drawerNav.querySelector('[data-drawer-nav-close]');
    this.mainFlyout = this.drawerNav.querySelector('[data-drawer-main-flyout]');
    this.overlay = this.drawerNav.querySelector('[data-drawer-overlay]');
    this.submenuTriggers = this.drawerNav.querySelectorAll('[data-drawer-submenu-button="tier-1"]');

    this.abortController = new AbortController();
    this.escAbortController = null;

    this.flyoutAnimation = transition({ el: this.mainFlyout, state: 'closed' });
    this.overlayAnimation = transition({ el: this.overlay, state: 'closed' });

    this.closeEsc = e => {
      if (e.key === 'Escape') {
        this.close();
      }
    };

    const { signal } = this.abortController;
    this.drawerTrigger.addEventListener('click', () => this.open(), { signal });
    this.closeButton.addEventListener('click', () => this.close(), { signal });
    this.overlay.addEventListener('click', () => this.close(), { signal });

    this.submenuTriggers.forEach(submenuTrigger => {
      submenuTrigger.addEventListener('click', e => this.openSubmenu(e), { signal });
    });

    // Currency and Language selectors
    this.countryDisclosureEl = this.drawerNav.querySelector('[data-disclosure-country]');
    this.localeDisclosureEl = this.drawerNav.querySelector('[data-disclosure-locale]');
    this.disclosures = [];

    if (this.countryDisclosureEl) {
      this.disclosures.push(new Disclosure(this.countryDisclosureEl));
    }

    if (this.localeDisclosureEl) {
      this.disclosures.push(new Disclosure(this.localeDisclosureEl));
    }
  }

  open() {
    this.drawerNav.dataset.open = true;
    this.flyoutAnimation.animateTo('open');
    this.overlayAnimation.animateTo('open');

    this.escAbortController = new AbortController();
    window.addEventListener('keydown', e => this.closeEsc(e), { signal: this.escAbortController.signal });

    this.drawerNav.focus();
    trapFocus(this.drawerNav);
  }

  close() {
    removeTrapFocus(this.drawerNav);
    this.drawerTrigger.focus();

    this.drawerNav.dataset.childOpen = false;

    if (this.escAbortController) {
      this.escAbortController.abort();
      this.escAbortController = null;
    }

    this.flyoutAnimation.animateTo('closed');
    this.overlayAnimation.animateTo('closed')
      .then(() => {
        this.drawerNav.dataset.open = false;

        if (this.submenu) {
          this.submenu.unload();
        }
      });
  }

  openSubmenu(e) {
    const submenuTrigger = e.target;
    const submenu = submenuTrigger.nextElementSibling;

    this.drawerNav.dataset.childOpen = true;

    this.submenu = new DrawerNavSubmenu({
      submenu,
      trigger: submenuTrigger,
      parentMenu: this.drawerNav,
      tier: 2,
      drawerMenu: this,
    });
  }

  unload() {
    if (this.submenu) {
      this.submenu.unload();
    }

    this.flyoutAnimation.animateTo('closed', { force: true });
    this.overlayAnimation.animateTo('closed', { force: true });

    this.flyoutAnimation.unload();
    this.overlayAnimation.unload();
    this.disclosures.forEach(disclosure => disclosure.unload());
    this.abortController.abort();
    if (this.escAbortController) {
      this.escAbortController.abort();
    }
  }
}
